import { Switch } from '@repo/design-system/index'
import { useEffect, useState } from 'react'
import apis from '../../../../modules/apis'
import { axiosPost } from '../../../../modules/axiosHelper'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { IC_TEENS_BOOK } from '../../../../modules/images'

const SelfIntroPanel = ({ data, teens }: { data: any; teens: any }) => {
  const { t, isLocaleKO } = useTranslation()

  const [introductionList, setIntroductionList] = useState(teens ? data.intro.slice(0, 4) : data.intro)
  const [showKorean, setShowKorean] = useState(false)

  const translateContents = async (introductionList) => {
    const arr = await Promise.all(
      introductionList.map(async (item) => {
        try {
          const response = await axiosPost(apis.googleTranslate(), {
            text: item.content,
            mode: 'en_ko',
          })
          if (response.success) {
            return { ...item, content: response.translated }
          } else {
            console.error(response.message)
            return item
          }
        } catch (error) {
          console.error(error)
          return item
        }
      })
    )

    setIntroductionList(arr)
  }

  useEffect(() => {
    if (!showKorean && introductionList) {
      setIntroductionList(data.intro)
    }
  }, [showKorean])

  useEffect(() => {
    if (showKorean && introductionList) {
      translateContents(introductionList)
    }
  }, [showKorean])
  return (
    <div className="px-[16px]">
      {isLocaleKO && (
        <div className="">
          <div className="flex flex-row items-center justify-end">
            <span className="Body2-14Md mr-[8px] text-gray-500">한글로 보기</span>
            <Switch checked={showKorean} setChecked={setShowKorean} />
          </div>
        </div>
      )}
      <div className="flex flex-col gap-y-[40px]">
        {introductionList.map((item, i) => (
          <div key={i}>
            <div className="Title1-20Bd">{item.title}</div>
            <div className="Body1-16Md mt-[4px] text-gray-700">{item.content}</div>
          </div>
        ))}
      </div>
      {data.books?.length > 0 && (
        <div>
          <div className="mb-[8px] font-medium text-black">Books I am confident in teaching</div>
          {data.books.map((book, i) => (
            <div key={i} className="mb-[16px] flex">
              <img src={IC_TEENS_BOOK} className="h-[20px] w-[20px]" />
              <div className="ml-[8px]">
                <div className="text-h5 mb-[4px] text-gray-700">{book.title}</div>
                <div className="text-h6 text-gray-700">{book.author}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
export default SelfIntroPanel
